/**
 * Persist Model Studio "Curated Models" per room (room object ids + display metadata).
 * Thumbnails are refreshed from the API when Model Studio opens.
 */

function storageKey(roomId) {
  return `photorealistic:curated:${String(roomId)}`;
}

/** @param {Array<{ id?: unknown, name?: string, category?: string, thumbSrc?: string }>} items */
export function normalizeCuratedModelsForStorage(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => {
      const id = item?.id;
      if (id == null) return null;
      return {
        id,
        name: item?.name ?? 'Model',
        category: item?.category ?? 'Other',
      };
    })
    .filter(Boolean);
}

export function loadCuratedModelsForRoom(roomId) {
  if (roomId == null) return [];
  try {
    const raw = localStorage.getItem(storageKey(roomId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return normalizeCuratedModelsForStorage(parsed);
  } catch {
    return [];
  }
}

export function saveCuratedModelsForRoom(roomId, items) {
  if (roomId == null) return;
  try {
    const normalized = normalizeCuratedModelsForStorage(items);
    if (normalized.length === 0) {
      localStorage.removeItem(storageKey(roomId));
    } else {
      localStorage.setItem(storageKey(roomId), JSON.stringify(normalized));
    }
  } catch (err) {
    console.error('Failed to save curated models for room', roomId, err);
  }
}

export function clearCuratedModelsForRoom(roomId) {
  if (roomId == null) return;
  try {
    localStorage.removeItem(storageKey(roomId));
  } catch {
    /* ignore */
  }
}
